import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { PublicationService } from '../services/publication.service';
import { Publication } from '../interfaces/publication';
import { Subscription } from 'rxjs';

@Pipe({ name: 'sharedPublicationIdToName' })
export class SharedPublicationIdToName implements PipeTransform, OnDestroy {
	publications: any = {};
	pubServiceSubscription: Subscription;

	constructor(private publicationService: PublicationService) { }

	transform(item: string | number): Promise<any> {
		const returnPromise = new Promise((resolve: any) => {
			if (this.publications && this.publications[item.toString()]) {
				resolve(this.publications[item.toString()]);
			}

			this.pubServiceSubscription = this.publicationService.getData().subscribe((data: Publication) => {
				if (data.sharingPublications && Array.isArray(data.sharingPublications)) {
					this.publications = {};
					this.publications[data.id] = data.name;
					for (const publication of data.sharingPublications) {
						if (publication.id && publication.name) {
							this.publications[publication.id] = publication.name;
						}
					}
				}
			});

			resolve(this.publications[item.toString()] || '');
		});

		return returnPromise;
	}

	ngOnDestroy() {
		if (this.pubServiceSubscription) {
			this.pubServiceSubscription.unsubscribe();
		}
	}
}
